module.exports = __webpack_public_path__ + "static/media/pin_buckle_steel_polished.29dc4782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pin_buckle_steel_polished.png
// module id = 108
// module chunks = 0